import React from "react";

const inputStyles = "border-2 border-gray-300 rounded-md p-1 w-full";
const labelStyles = "flex-1 mr-1";

const BlockedEmailForm = ({ email, setEmail, isLoading, setIsValid }) => {
    const [errorMessage, setErrorMessage] = React.useState("");

    const checkFormValidity = (newEmail) => {
        setIsValid(false);
        if (newEmail === "") {
            setErrorMessage("Email is required");
            return;
        }
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        if (!isValidEmail) {
            setErrorMessage("Email is not valid");
            return;
        }
        setIsValid(true);
        setErrorMessage("");
    };

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    React.useEffect(() => {
        checkFormValidity(email);
    }, [email]);

    return (
        <form
            className={`w-100 mx-2 ${isLoading === true ? "opacity-50 cursor-not-allowed" : ""
                }`}
        >
            <label className={labelStyles}>
                <span className="block">Email to block</span>
                <input
                    disabled={isLoading}
                    required
                    className={inputStyles}
                    type="text"
                    name="email"
                    onChange={handleChange}
                    value={email}
                />
            </label>
            {errorMessage.length > 0 && (
                <p className="text-red-700 text-sm mt-2 bg-red-200 p-2">
                    {errorMessage}
                </p>
            )}
        </form>
    );
}

export { BlockedEmailForm };